import { Column, Txt } from '@stenajs-webui/core';
import { PrimaryButton, SecondaryButton, type TextInputButtonSize } from '@stenajs-webui/elements';
import { InformationMessageType } from './informationMessageUtils';
import { RegistrationNumberAlertFooter } from './RegistrationNumberAlertFooter';
import { RegistrationNumberAlertIcon } from './RegistrationNumberAlertIcon';

export interface RenderRegistrationNumberAlertAppliedIconProps {
  buttonSize?: TextInputButtonSize;
  fieldName: string;
  isEditingAllowed: boolean;
  onHideMessage: () => void;
  onIconClick: (type: 'ArrivalNotepad' | 'TravelledVehicle') => void;
  onRestore: () => void;
  showArrivalNotepad: boolean;
  showTravelledVehicle: boolean;
}

export const renderRegistrationNumberAlertAppliedIcon = ({
  fieldName,
  buttonSize,
  onIconClick,
  onHideMessage,
  onRestore,
  showTravelledVehicle,
  showArrivalNotepad,
  isEditingAllowed,
}: RenderRegistrationNumberAlertAppliedIconProps) => {
  if (!showArrivalNotepad && !showTravelledVehicle) {
    return null;
  }

  const getPopupText = () => {
    let text = `The ${fieldName} has been automatically updated with data from the quay unit with matching registration number.`;

    if (!isEditingAllowed) {
      text += ` It is no longer possible to change the ${fieldName} of the unit.`;
    }

    return text;
  };

  if (showArrivalNotepad) {
    return (
      <RegistrationNumberAlertIcon
        onClick={() => onIconClick('ArrivalNotepad')}
        title={`Updated ${fieldName}`}
        buttonSize={buttonSize}
        iconType={InformationMessageType.RegularInfo}
        renderPopupContent={requestClose => (
          <Column gap={2}>
            <Txt>{getPopupText()}</Txt>
            <RegistrationNumberAlertFooter>
              <PrimaryButton
                onClick={() => {
                  onHideMessage();
                  requestClose();
                }}
                label={'Ok, got it'}
              />
            </RegistrationNumberAlertFooter>
          </Column>
        )}
      />
    );
  }

  if (showTravelledVehicle) {
    return (
      <RegistrationNumberAlertIcon
        onClick={() => onIconClick('TravelledVehicle')}
        title={`Updated ${fieldName}`}
        buttonSize={buttonSize}
        iconType={InformationMessageType.RegularInfo}
        renderPopupContent={requestClose => (
          <Column gap={2}>
            <Txt>
              {`The ${fieldName} has been automatically updated based on data from the previous booking with the same registration number.`}
            </Txt>
            <RegistrationNumberAlertFooter>
              <SecondaryButton
                onClick={() => {
                  onRestore();
                  requestClose();
                }}
                label={`Restore default ${fieldName}`}
              />
              <PrimaryButton
                onClick={() => {
                  onHideMessage();
                  requestClose();
                }}
                label={'Ok, got it'}
              />
            </RegistrationNumberAlertFooter>
          </Column>
        )}
      />
    );
  }

  return null;
};
